import { Component, Input, OnInit, Output, TemplateRef, ViewChild, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AchievementsService } from '@results/services/achievements.service';
import { MarketService, AccountService } from '@app/core/services';
import { HandlerService } from '@app/_services/handler.service';
import { Award, Purchase, Profile } from '@df/interfaces';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { declensionOfNumerals } from '@app/_utils/helpers';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { sortBy as _sortBy } from 'lodash';

@Component({
    selector: 'app-page-item',
    templateUrl: './page-item.component.html',
    styleUrls: ['./page-item.component.scss']
})
export class PageItemComponent implements OnInit {
    @ViewChild('confirmDeleteLink', { static: true }) cconfirmDeleteLink: TemplateRef<any>;
    @Input() forTeacher = false;
    @Output() deleteAwardEmitter = new EventEmitter();

    award: Award;
    awards: Array<Award>;
    purchase: Purchase;
    purchases: Array<Purchase>;
    activatedImage: string;
    showSpinner: boolean = true;
    currencyStr = '';
    cardAward: any;
    userId: number;
    isStudent = false;
    profile: Profile;
    form: FormGroup;
    filesLinks: Array<string> = [];

    dialogRef: any;

    constructor(
        private activatedRoute: ActivatedRoute,
        private achievementsService: AchievementsService,
        private marketService: MarketService,
        private handlerService: HandlerService,
        private accountService: AccountService,
        private fb: FormBuilder,
        public dialog: MatDialog,
        private router: Router,
        private sanitizer: DomSanitizer
    ) {
        this.activatedRoute.params.subscribe(params => {
            let awardId: number = params['award_id'];
            const purchaseId: number = params['purchase_id'];

            if (!awardId) {
                awardId = JSON.parse(localStorage.getItem('selectedAward'));
            }
            this.getAward(awardId);

            if (purchaseId) {
                this.getPurchase(purchaseId);
            }
        });
    }

    ngOnInit() {
        const reg =
            '(https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}' +
            '|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\\/\\/(?:www\\.|' +
            '(?!www))[a-zA-Z0-9]+\\.[^\\s]{2,}|www\\.[a-zA-Z0-9]+\\.[^\\s]{2,})';
        this.profile = JSON.parse(localStorage.getItem('profile'));
        if (this.profile && this.profile.group.name === 'Студент') {
            this.isStudent = true;
        }

        this.form = this.fb.group({
            date: [new Date(), []],
            for_what: [''],
            comment: [''],
            url: ['', Validators.pattern(reg)]
        });
    }

    private getAward(awardId: number): void {
        this.achievementsService.getAward(awardId).subscribe(
            resp => {
                this.handlerService.checkErrors(resp);
                if (!resp.errors.length) {
                    this.award = resp.data;
                    this.userId = this.award.user_id;
                    this.getCardAward();
                    this.getDuplicateCardAwards();
                }
            },
            error => console.log(error)
        );
    }

    private getPurchase(purchaseId: number): void {
        this.marketService.getPurchase(purchaseId).subscribe(
            resp => {
                this.handlerService.checkErrors(resp);
                if (!resp.errors.length) {
                    this.purchase = resp.data;
                    this.showSpinner = false;
                    this.activatedImage = this.purchase.product.preview.url;
                    this.getCurrentCerrency();
                    this.getSummaryDealProducts();
                    this.getMediumPrice();
                }
            },
            error => console.log(error)
        );
    }

    private getSummaryDealProducts(): void {
        this.marketService.getSummaryDealProducts(this.purchase.product.id).subscribe(resp => {
            this.purchase.summary_product_count = resp;
        });
    }

    private getMediumPrice(): void {
        this.marketService.getMediumPrice(this.purchase.product.id).subscribe(resp => {
            this.purchase.medium_price = resp;
        });
    }

    private getCurrentCerrency() {
        this.accountService.getCurrentCurrency().subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (!resp.errors.length) {
                this.currencyStr = declensionOfNumerals(this.purchase.medium_price, resp.data);
            }
        });
    }

    private getDuplicateCardAwards(): void {
        const cardType: string = this.cardType;
        const cardId: number = this.cardAward.id;
        this.achievementsService.getDuplicateCardAwards(this.userId, cardType, cardId).subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (!resp.errors.length) {
                this.awards = _sortBy(resp.data, ['is_used_card']);
                this.award = this.awards[0];
                this.showSpinner = false;
                this.userId = this.award.user_id;

                if (!this.isStudent) {
                    this.patchAwardData();
                }
            }
        });
    }

    getVideoUrl(url: string) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    getCardAward(): void {
        if (this.award.standart_card) {
            this.cardAward = this.award.standart_card;
        }

        if (this.award.named_card) {
            this.cardAward = this.award.named_card;
        }

        if (this.award.certificate) {
            this.cardAward = this.award.certificate;
        }

        this.activatedImage = this.cardAward.preview.url;
    }

    get cardType(): string {
        if (this.award.standart_card) {
            return 'standart_card';
        }

        if (this.award.named_card) {
            return 'named_card';
        }

        if (this.award.certificate) {
            return 'certificate';
        }

        return '';
    }

    back() {
        if (this.award) {
            this.router.navigate([`profile/awards/${this.userId}`]);
        }

        if (this.purchase) {
            this.router.navigate(['profile/purchases']);
        }
    }

    getPaginatorData(event: PageEvent) {
        if (this.award) {
            this.award = this.awards[event.pageIndex];
            this.patchAwardData();
        }

        if (this.purchase) {
            this.purchase = this.purchases[event.pageIndex];
        }
        return event;
    }

    addLink(): void {
        const link = this.form.value.url;
        if (link && this.form.controls.url.valid) {
            this.filesLinks.push(link);

            this.form.patchValue({
                url: ''
            });

            return;
        }
        this.handlerService.errorMsg('Неправильная ссылка');
    }

    deleteCurrentLink(): void {
        const link = this.form.value.url;
        const index = this.filesLinks.indexOf(link);

        if (index > -1) {
            this.filesLinks.splice(index, 1);
        }

        this.form.patchValue({
            url: ''
        });
    }

    showLink(link: string): void {
        this.form.patchValue({
            url: link
        });
    }

    private patchAwardData(): void {
        this.filesLinks = [];
        this.award.urls.forEach(it => {
            this.filesLinks.push(it.link);
        });
        this.form.patchValue({
            date: this.award.date,
            comment: this.award.comment,
            for_what: this.award.for_what,
            url: ''
        });
    }

    updateData(): void {
        const data = {
            comment: this.form.value.comment,
            urls: this.filesLinks,
            for_what: this.form.value.for_what,
            date: this.form.value.date
        };

        this.achievementsService.updateStudentsAwards(this.award.id, data).subscribe(
            resp => {
                if (!resp.error) {
                    this.handlerService.successMsg('Награда успешно обновленна');
                }
            },
            error => {
                console.log(error);
                this.handlerService.successMsg('Произошла ошибка попробуйте снова');
            }
        );
    }

    openDialog(template: TemplateRef<any>): void {
        this.dialogRef = this.dialog.open(template, {
            width: '500px',
            height: '200px'
        });
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    deleteLink(): void {
        this.openDialog(this.cconfirmDeleteLink);
    }

    deleteAward(): void {
        this.closeDialog();
        this.achievementsService.deleteAward(this.award.id).subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (!resp.error) {
                this.deleteAwardEmitter.emit();
            }
        });
    }
}
